/**
 * Function that returns value for aria-described-by attribute
 * @param instructionalText
 * @param descriptionId
 * @param charCounterMax
 * @param charCounterId
 */
function getAriaDescribedBy(instructionalText, descriptionId, charCounterMax, charCounterId) {
    const _descriptionId = instructionalText ? descriptionId : '';
    const _charCounterId = charCounterMax ? charCounterId : '';
    if (!_descriptionId && !_charCounterId)
        return null;
    return `${_descriptionId} ${_charCounterId}`.trim();
}

export { getAriaDescribedBy as g };
